(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
document.addEventListener('click', async (event) => {
  const link = event.target.closest('[data-pmu-cookie-preferences]');
  if (!link || !window.privacyBanner?.showPreferences) return;
  event.preventDefault();
  try {
    await window.privacyBanner.showPreferences();
  } catch {
    window.location.assign(link.href);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reset-pmu-rollout"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('.pmu-premium a[href^="#pmu-source-"]');
  if (!link) return;
  const target = document.getElementById(link.hash.slice(1));
  if (!target) return;
  event.preventDefault();
  let ancestor = target.parentElement;
  while (ancestor) {
    if (ancestor.tagName === 'DETAILS') ancestor.open = true;
    ancestor = ancestor.parentElement;
  }
  target.setAttribute('tabindex', '-1');
  target.focus({preventScroll: true});
  target.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'});
});

  } catch(e) { console.error(e); }
})();
})();
